import React, { useEffect, useContext, useState, useRef } from 'react'
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import {
  Box,
  Button,
} from '@material-ui/core';

import SuperAdminContext from "../../../contexts/SuperAdminContext"

import TopBar from "../../../components/ui/Admin/TopBar"
import GroupCard from "../../../components/ui/Admin/Groups/GroupCard"

const Groups = () => {
  const navigate = useNavigate()

  const { groupes, updateAdminGroupes, ecoles } = useContext(SuperAdminContext)

  const [diplomesNames, setDiplomesNames] = useState([])
  const [ecolesDispo, setEcolesDispo] = useState([])
  const [typesDispo, setTypesDispo] = useState([{isTheScanGroupe : 0, name:"TheLab"}, {isTheScanGroupe : 1, name:"TheScan"}])

  const [groupsDisplay, setGroupsDisplay] = useState([])
  const [allGroups, setAllGroups] = useState([])

  const [filters, setFilters] = useState({ecoles : [], diplomes : [], types : []})

  const resetFilterTypes = () => {
    let elem = document.getElementById("filterTypes")
    if (elem) {
      Array.from(elem?.options).forEach((o) => {
        o.selected = false
      })
    }
    setFilters({
      ...filters,
      types: []
    });
  }

  const resetFilterEcoles = () => {
    let elem = document.getElementById("filterEcoles")
    if (elem) {
      Array.from(elem?.options).forEach((o) => {
        o.selected = false
      })
    }
    setFilters({
      ...filters,
      ecoles: []
    });
  }

  const resetFilterDiplomes = () => {
    let elem = document.getElementById("filterDiplomes")
    if (elem) {
      Array.from(elem?.options).forEach((o) => {
        o.selected = false
      })
      setFilters({
        ...filters,
        diplomes: []
      });
    }
  }

  useEffect(() => {
    if (groupes && ecoles) {
      let diplomesArr = []
      groupes?.forEach((g) => {
        if (g.diplome && g.diplome.length > 1) {
          diplomesArr.push(g.diplome)
        }
      })

      let uniqueDiplomesArr = [...new Set(diplomesArr)];
      setDiplomesNames(uniqueDiplomesArr)
      setEcolesDispo(ecoles)
      setAllGroups(groupes)
      resetFilterEcoles()
      resetFilterDiplomes()
      setFilters({ecoles : [], diplomes : [], types: []})
    }
  }, [groupes, ecoles])

  useEffect(() => {
    let finalGroups = [...allGroups]
    if (filters?.ecoles?.length === 0 && filters?.diplomes?.length === 0 && filters?.types?.length === 0) {
      setGroupsDisplay(finalGroups)
    } else {
      if (filters?.types?.length > 0) {
        finalGroups = finalGroups.filter((el) => {
          return filters?.types?.some((type) => parseInt(type) === el.isTheScanGroupe)
        })
      }

      if (filters?.ecoles?.length > 0) {
        let allGroupsIds = []
        filters?.ecoles?.forEach((eclID) => {
          let findEcole = ecoles.find((el) => el.id === parseInt(eclID))
          findEcole?.groupes?.forEach((grp) => {
            allGroupsIds.push(grp.groupeID)
          })
        })
        allGroupsIds = [...new Set(allGroupsIds)];

        finalGroups = finalGroups.filter((el) => {
          return allGroupsIds.some((id) => id === el.id)
        })
      }

      if (filters?.diplomes?.length > 0) {
        finalGroups = finalGroups.filter((el) => {
          return filters?.diplomes?.some((d) => d === el.diplome)
        })
      }

      setGroupsDisplay(finalGroups)
    }
  }, [filters, allGroups])

  return (
    <>
      <Helmet>
        <title>Admin Groupes | TheLab</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.grey',
          minHeight: '100%',
          py: 0,
          display:"flex",
          flexDirection:"column",
        }}
      >
        <Box
          sx={{
            flex:1,
            padding:"20px",
            backgroundColor:"background.grey",
          }}
        >
          <TopBar
            title="Liste des Groupes"
          >
            <Button
              variant="contained"
              sx={{ minHeight:"35px !important" }}
              onClick={() => { updateAdminGroupes(true) }}
            >
              Voir les archives
            </Button>
            <Button
              variant="contained"
              sx={{ minHeight:"35px !important" }}
              onClick={() => { navigate('/admin/groupe/add') }}
            >
              + Groupe
            </Button>
          </TopBar>


          <Box sx={{
            padding:"10px 10px 30px 10px",
            display:"flex",
            width:"100%",
            justifyContent:"space-evenly",
            gap:"10px",
            flexWrap:"wrap"
          }}>
            <Box sx={{display:"flex", gap:'5px'}}>
              <Box sx={{display:"flex", flexDirection:"column", alignItems:"center", gap:"5px"}}>
                <Box>Filtre par types :</Box>
                <Box sx={{fontSize:"12px"}}>
                {filters?.types?.length < 2 &&
                  <>({filters?.types?.length} sélectionné)</>
                }
                {filters?.types?.length >= 2 &&
                  <>({filters?.types?.length} sélectionnés)</>
                }
                </Box>
                <button
                  style={{width:"50px", marginTop:"5px"}}
                  onClick={(e) => { resetFilterTypes() }}
                >
                  Vider
                </button>
              </Box>
              <select
                multiple
                onChange={(e) => {
                  let newArr = []
                  Array.from(e.target.options).forEach((o) => {
                    if (o.selected === true) {
                      newArr.push(o.value)
                    }
                  })
                  setFilters({
                    ...filters,
                    types: newArr
                  });
                }}
                name="filterTypes"
                id="filterTypes"
                style={{width:"150px", height:"75px", padding:"1px"}}
              >
                {typesDispo.map((type, index) => {
                  return (
                    <option key={type.isTheScanGroupe} value={type.isTheScanGroupe}>{type.name}</option>
                  )
                })}
              </select>
            </Box>
            <Box sx={{display:"flex", gap:'5px'}}>
              <Box sx={{display:"flex", flexDirection:"column", alignItems:"center", gap:"5px"}}>
                <Box>Filtre par écoles :</Box>
                <Box sx={{fontSize:"12px"}}>
                {filters?.ecoles?.length < 2 &&
                  <>({filters?.ecoles?.length} sélectionné)</>
                }
                {filters?.ecoles?.length >= 2 &&
                  <>({filters?.ecoles?.length} sélectionnés)</>
                }
                </Box>
                <button
                  style={{width:"50px", marginTop:"5px"}}
                  onClick={(e) => { resetFilterEcoles() }}
                >
                  Vider
                </button>
              </Box>
              <select
                multiple
                onChange={(e) => {
                  let newArr = []
                  Array.from(e.target.options).forEach((o) => {
                    if (o.selected === true) {
                      newArr.push(o.value)
                    }
                  })
                  setFilters({
                    ...filters,
                    ecoles: newArr
                  });
                }}
                name="filterEcoles"
                id="filterEcoles"
                style={{width:"150px", height:"75px", padding:"1px"}}
              >
                {ecolesDispo.map((ecole, index) => {
                  return (
                    <option key={ecole.id} value={ecole.id}>{ecole.name}</option>
                  )
                })}
              </select>
            </Box>
            <Box sx={{display:"flex", gap:'5px'}}>
              <Box sx={{display:"flex", flexDirection:"column", alignItems:"center", gap:"5px"}}>
                <Box>Filtre par diplômes :</Box>
                <Box sx={{fontSize:"12px"}}>
                {filters?.diplomes?.length < 2 &&
                  <>({filters?.diplomes?.length} sélectionné)</>
                }
                {filters?.diplomes?.length >= 2 &&
                  <>({filters?.diplomes?.length} sélectionnés)</>
                }
                </Box>
                <button
                  style={{width:"50px"}}
                  onClick={(e) => { resetFilterDiplomes() }}
                >
                  Vider
                </button>
              </Box>
              <select
                multiple
                onChange={(e) => {
                  let newArr = []
                  Array.from(e.target.options).forEach((o) => {
                    if (o.selected === true) {
                      newArr.push(o.value)
                    }
                  })
                  setFilters({
                    ...filters,
                    diplomes: newArr
                  });
                }}
                name="filterDiplomes"
                id="filterDiplomes"
                style={{width:"150px", height:"75px", padding:"1px"}}
              >
                {diplomesNames.map((d, index) => {
                  return (
                    <option key={d} value={d}>{d}</option>
                  )
                })}
              </select>
            </Box>
          </Box>
          {groupsDisplay?.length === 0 ? (
            <Box sx={{textAlign:"center", width:"100%", fontWeight:"bold"}}>
              Pas de correspondance
            </Box>
          ) : (
            <Box sx={{
              display:"flex",
              flexWrap:"wrap",
              justifyContent:"space-between",
              width:"100%",
              padding : "10px",
              flexWrap:"wrap",
              gap:"30px",
            }}>
              {groupsDisplay.map((group, i) => {
                return (<GroupCard group={group} key={i} />)
              })}
            </Box>
          )}

        </Box>
      </Box>
    </>
  )
};

export default Groups;
